// Decimal values are rounded, so 2.1, 3.1, 3.2 are rounded to 2, 3, 3 for the stepper
export const SIGN_UP_STEPS = {
  CREDENTIALS: 1,

  PERSONAL_INFO: 2,
  EMAIL_VERIFICATION: 2.1,

  VERIFY_PHONE: 3,
  OTP_VERIFICATION: 3.1,

  CONGRATS: 4,

  REDIRECT_TO_ONE: 5,
};

export const AUTH_PROVIDERS = {
  GOOGLE: 'Google',
  FACEBOOK: 'Facebook',
};
